import { Button, Modal } from '@/components/ui/daisy';
import { EmptyActivitiesError } from '../useContPedStatus';
import { ValidationErrorProps } from './ValidationErrorHandler';
import { useTranslation } from 'react-i18next';
import { useModalDialog } from '@/components/ui/daisy/modal/hooks';

export default function EmptyActivitiesFeedback({
  error,
  onClose,
}: ValidationErrorProps<EmptyActivitiesError>) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.courseWorkspace.validation.emptyActivities',
  });
  const { ref, close } = useModalDialog(error, onClose);
  return (
    <Modal ref={ref}>
      <Modal.Box>
        <Modal.Close onClick={close} />
        <h3 className="text-lg font-bold">{t('title')}</h3>
        <p className="py-2">{t('description')}</p>
        <ul className="list-disc pl-5 space-y-1">
          {error.payload.map(activity => (
            <li key={activity.id}>
              {t('item', {
                name: activity.name,
                lessons: activity.lesson.join(', '),
              })}
            </li>
          ))}
        </ul>
        <Modal.Action>
          <Button onClick={close}>{t('close')}</Button>
        </Modal.Action>
      </Modal.Box>
      <Modal.Backdrop />
    </Modal>
  );
}
